<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">#</th>
          <th class="text-center">Ninja ID</th>
          <th>Nome</th>
          <th class="text-center">Status</th>
          <th>Criado por</th>
          <th>Atualizado por</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="board in boards" :key="board.id">
          <td class="text-center">{{ board.id }}</td>
          <td class="text-center">{{ board.ninjaId }}</td>
          <td>{{ board.name }}</td>
          <td v-html="statusTranslate(board.status)" class="text-center" />
          <td>
            {{ createdUpdatedUser(board.createdBy, board.createdAt) }}
          </td>
          <td>
            {{ createdUpdatedUser(board.updatedBy, board.updatedAt) }}
          </td>
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-danger btn-icon"
              title="Excluir"
              @click="$emit('deleteBoard', board.id)"
            >
              <i class="ph ph-trash" />
            </button>
            <button
              type="button"
              class="btn btn-outline-warning btn-icon ms-2"
              title="Editar"
              @click="$emit('createEditBoard', board.id)"
            >
              <i class="ph ph-pencil" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'

export default {
  name: 'ListBoards',

  props: {
    boards: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListBoards',
        columnDefs: [
          {
            targets: [4, 5, 6],
            orderable: false,
          },
          {
            targets: [6],
            width: 120,
          },
        ],
      },
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
